// Config sections that are NOT their own Settings tab: the page renders them
// inline inside another panel (nodes.* = Auto-Retire After (hours), shown
// directly above the Retired Nodes list in System). Import-free so the unit
// tests can load it; value = the category the section is shown in.
export const CONFIG_INLINE_SECTIONS: Record<string, string> = {
  nodes: "system",
};

export const AUTO_RETIRE_TOOLTIP =
  "A repeater or room server with no verified advert for this long is retired until its next advert; 0 disables";
